import dynamic from "next/dynamic";
import { Builder } from "@builder.io/react";
import { toolkitColors } from "@/utils/constants";

const FeatureCarousel = dynamic(async () => {
  return (await import("./FeatureCarousel")).default;
});

Builder.registerComponent(FeatureCarousel, {
  name: "Feature carousel",
  inputs: [
    {
      name: "backgroundColor",
      type: "string",
      defaultValue: "Oat",
      enum: toolkitColors,
      helperText: "Background color for the Carousel",
    },
    {
      name: "carouselHeader",
      type: "string",
      helperText: "Feature Carousel Header (Character limit - 38)",
      onChange: `if(options.get("carouselHeader").length > 38) {options.set("carouselHeader", options.get("carouselHeader").slice(0, 38));alert("Maximum number of characters is 38")}`,
    },
    {
      name: "carouselBody",
      type: "longText",
      helperText: "Feature Carousel Body (Character limit - 150)",
      onChange: `if(options.get("carouselBody").length > 150) {options.set("carouselBody", options.get("carouselBody").slice(0, 65));alert("Maximum number of characters is 150")}`,
    },
    {
      name: "ctaText",
      type: "string",
      helperText: "Feature Carousel CTA text",
    },
    {
      name: "ctaUrl",
      type: "url",
      helperText: "Feature Carousel CTA destination url",
    },
    {
      name: "zoomEffect",
      type: "boolean",
      defaultValue: "true",
      helperText:
        "Turn this on to enable the zoom effect on image cards",
    },
    {
      name: "cardList",
      type: "list",
      subFields: [
        {
          name: "productOrImage",
          type: "string",
          defaultValue: "image",
          enum: ["product", "image"],
          helperText: "Choose Product or Image to be displayed in the Carousel",
        },
        {
          name: "product",
          type: "ShopifyProduct",
          hideFromInsertMenu: true,
          showIf: `options.get('productOrImage') === 'product'`,
          helperText: "Shopify Product Card",
        },
        {
          name: "image",
          type: "file",
          allowedFileTypes: ["jpeg", "png", "gif"],
          showIf: `!options.get('productOrImage') || options.get('productOrImage') === 'image'`,
          helperText: "Image Card Desktop",
        },
        {
          name: "imageAlt",
          type: "string",
          helperText: "Image alt text",
        },
        {
          name: "imageTablet",
          type: "file",
          allowedFileTypes: ["jpeg", "png", "gif"],
          showIf: `!options.get('productOrImage') || options.get('productOrImage') === 'image'`,
          helperText: "Image Card Tablet",
        },
        {
          name: "imageMobile",
          type: "file",
          allowedFileTypes: ["jpeg", "png", "gif"],
          showIf: `!options.get('productOrImage') || options.get('productOrImage') === 'image'`,
          helperText: "Image Card Mobile",
        },
        {
          name: "header",
          type: "string",
          helperText: "Image Card Header (Character limit - 30)",
          onChange: `if(options.get("header").length > 30) {options.set("header", options.get("header").slice(0, 30));alert("Maximum number of characters is 30")}`,
          showIf: `options.get('productOrImage') === 'image'`,
        },
        {
          name: "body",
          type: "string",
          helperText: "Image Card Body (Character limit - 65)",
          onChange: `if(options.get("body").length > 65) {options.set("body", options.get("body").slice(0, 65));alert("Maximum number of characters is 65")}`,
          showIf: `options.get('productOrImage') === 'image'`,
        },
        {
          name: "url",
          type: "url",
          helperText: "Image Card URL",
          showIf: `options.get('productOrImage') === 'image'`,
        },
        {
          name: "superBrands",
          type: "boolean",
          defaultValue: false,
          helperText:
            "Enable this to add superbrands storytelling feature on click of the image card or to add an inner feature carousel on click of the image card",
          showIf: `!options.get('productOrImage') || options.get('productOrImage') === 'image'`,
        },
        {
          name: "storyTellingOrFeatureCarousel",
          type: "string",
          defaultValue: "Story Telling",
          enum: ["Story Telling", "Feature Carousel"],
          helperText:
            "Choose between adding a superbrands storytelling feature or a feature carousel on click of the image card",
          showIf: `options.get('productOrImage') === 'image' && options.get('superBrands')`,
        },
        {
          name: "storyTellingImage",
          type: "file",
          allowedFileTypes: ["jpeg", "png", "gif"],
          helperText: "Story Telling Image",
          showIf: `options.get('productOrImage') === 'image' && options.get('superBrands') && options.get('storyTellingOrFeatureCarousel') === 'Story Telling'`,
        },
        {
          name: "storyTellingHeader",
          type: "string",
          helperText: "Story Telling Header (Character limit - 50)",
          onChange: `if(options.get("storyTellingHeader").length > 50) {options.set("storyTellingHeader", options.get("storyTellingHeader").slice(0, 50));alert("Maximum number of characters is 50")}`,
          showIf: `options.get('productOrImage') === 'image' && options.get('superBrands') && options.get('storyTellingOrFeatureCarousel') === 'Story Telling'`,
        },
        {
          name: "storyTellingBody",
          type: "longText",
          helperText: "Story Telling Header (Character limit - 220)",
          onChange: `if(options.get("storyTellingBody").length > 220) {options.set("storyTellingBody", options.get("storyTellingBody").slice(0, 220));alert("Maximum number of characters is 220")}`,
          showIf: `options.get('productOrImage') === 'image' && options.get('superBrands') && options.get('storyTellingOrFeatureCarousel') === 'Story Telling'`,
        },
        {
          name: "storyTellingCtaText",
          type: "string",
          helperText: "Story Telling CTA text",
          showIf: `options.get('productOrImage') === 'image' && options.get('superBrands') && options.get('storyTellingOrFeatureCarousel') === 'Story Telling'`,
        },
        {
          name: "storyTellingCtaUrl",
          type: "url",
          helperText: "Story Telling CTA destination url",
          showIf: `options.get('productOrImage') === 'image' && options.get('superBrands') && options.get('storyTellingOrFeatureCarousel') === 'Story Telling'`,
        },
        {
          name: "storyTellingBackgroundColor",
          type: "string",
          defaultValue: "Silk",
          enum: toolkitColors,
          helperText: "Story Telling Background color",
          showIf: `options.get('productOrImage') === 'image' && options.get('superBrands') && options.get('storyTellingOrFeatureCarousel') === 'Story Telling'`,
        },
        {
          name: "_backgroundColor",
          type: "string",
          defaultValue: "Oat",
          enum: toolkitColors,
          helperText: "Background color for the Carousel",
          showIf: `options.get('productOrImage') === 'image' && options.get('superBrands') && options.get('storyTellingOrFeatureCarousel') === 'Feature Carousel'`,
        },
        {
          name: "_carouselHeader",
          type: "string",
          helperText: "Feature Carousel Header (Character limit - 38)",
          onChange: `if(options.get("_carouselHeader").length > 38) {options.set("_carouselHeader", options.get("_carouselHeader").slice(0, 38));alert("Maximum number of characters is 38")}`,
          showIf: `options.get('productOrImage') === 'image' && options.get('superBrands') && options.get('storyTellingOrFeatureCarousel') === 'Feature Carousel'`,
        },
        {
          name: "_carouselBody",
          type: "longText",
          helperText: "Feature Carousel Body (Character limit - 150)",
          onChange: `if(options.get("_carouselBody").length > 150) {options.set("_carouselBody", options.get("_carouselBody").slice(0, 65));alert("Maximum number of characters is 150")}`,
          showIf: `options.get('productOrImage') === 'image' && options.get('superBrands') && options.get('storyTellingOrFeatureCarousel') === 'Feature Carousel'`,
        },
        {
          name: "_ctaText",
          type: "string",
          helperText: "Feature Carousel CTA text",
          showIf: `options.get('productOrImage') === 'image' && options.get('superBrands') && options.get('storyTellingOrFeatureCarousel') === 'Feature Carousel'`,
        },
        {
          name: "_ctaUrl",
          type: "url",
          helperText: "Feature Carousel CTA destination url",
          showIf: `options.get('productOrImage') === 'image' && options.get('superBrands') && options.get('storyTellingOrFeatureCarousel') === 'Feature Carousel'`,
        },
        {
          name: "_cardList",
          type: "list",
          showIf: `options.get('productOrImage') === 'image' && options.get('superBrands') && options.get('storyTellingOrFeatureCarousel') === 'Feature Carousel'`,
          subFields: [
            {
              name: "_productOrImage",
              type: "string",
              defaultValue: "image",
              enum: ["product", "image"],
              helperText:
                "Choose Product or Image to be displayed in the Carousel",
            },
            {
              name: "_product",
              type: "ShopifyProduct",
              hideFromInsertMenu: true,
              showIf: `options.get('productOrImage') === 'product'`,
              helperText: "Shopify Product Card",
              showIf: `options.get('_productOrImage') === 'product'`,
            },
            {
              name: "_image",
              type: "file",
              allowedFileTypes: ["jpeg", "png", "gif"],
              helperText: "Image Card Desktop",
              showIf: `!options.get('_productOrImage') || options.get('_productOrImage') === 'image'`,
            },
            {
              name: "_imageAlt",
              type: "string",
              helperText: "Image alt text",
            },
            {
              name: "_imageTablet",
              type: "file",
              allowedFileTypes: ["jpeg", "png", "gif"],
              helperText: "Image Card Tablet",
              showIf: `!options.get('_productOrImage') || options.get('_productOrImage') === 'image'`,
            },
            {
              name: "_imageMobile",
              type: "file",
              allowedFileTypes: ["jpeg", "png", "gif"],
              helperText: "Image Card Mobile",
              showIf: `!options.get('_productOrImage') || options.get('_productOrImage') === 'image'`,
            },
            {
              name: "_header",
              type: "string",
              helperText: "Image Card Header (Character limit - 30)",
              onChange: `if(options.get("_header").length > 30) {options.set("_header", options.get("_header").slice(0, 30));alert("Maximum number of characters is 30")}`,
              showIf: `options.get('_productOrImage') === 'image'`,
            },
            {
              name: "_body",
              type: "string",
              helperText: "Image Card Body (Character limit - 65)",
              onChange: `if(options.get("_body").length > 65) {options.set("_body", options.get("_body").slice(0, 65));alert("Maximum number of characters is 65")}`,
              showIf: `options.get('_productOrImage') === 'image'`,
            },
            {
              name: "_url",
              type: "url",
              helperText: "Image Card URL",
              showIf: `options.get('_productOrImage') === 'image'`,
            },
          ],
        },
      ],
    },
  ],
});
